import ReactLoadingSkeleton from 'react-loading-skeleton';
import { Separator } from '~/components/granular/separator';
import { classNames } from '~/utils/styles';
import type { TabsSkeletonProps } from './TabsSkeleton.types';

export const TabsSkeleton = ({ count, staticItemsCount, ...props }: TabsSkeletonProps) => {
  const items = Array.from({ length: count ?? 5 }, (_, i) => i);
  const staticItems = Array.from({ length: staticItemsCount ?? 1 }, (_, i) => i);
  return (
    <div className="mt-1 flex h-[37px] border-b border-neutral-300" data-testid="skeleton-tabs" {...props}>
      <div className="py-2 pr-2">
        <ReactLoadingSkeleton borderRadius={1} height={16} width={135} />
      </div>

      {items.map((i) => (
        <TabSkeleton key={`skeleton-tab-${i}`} />
      ))}
      <div className="py-2">
        <Separator orientation="vertical" />
      </div>
      {staticItems.map((i) => (
        <TabSkeleton key={`skeleton-static-tab-${i}`} />
      ))}
    </div>
  );
};

const TabSkeleton = () => {
  const classes = classNames('px-2 py-2');
  return (
    <div className={classes}>
      <ReactLoadingSkeleton borderRadius={1} height={16} width={50} />
    </div>
  );
};
